exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".span_cv{\n    color: #ff7370;\n    font-size: 13px;\n}\n\n.span_job_info{\n    color: #9b9b9b;\n}\n\n.span_job_name{\n    color: #5b6c72;\n    font-weight: bold;\n    font-size: 16px;\n}\n\n.span_cand_name{\n    color: #5b6c72;\n    font-weight: bold;\n    font-size: 13px;\n    padding-right: 7px;\n}\n\n.row_job{\n    margin-top: 38px;\n}\n\n#table_item_candidates{\n    border: 1px solid #f1f1f1;\n    background-color: #fafafa;\n    padding: 8px;\n}\n\n#table_item_candidates td{\n    padding: 8px;\n    border-bottom: 1px solid #e9ebeb;\n}\n#table_item_candidates td:first-child{\n    width: 40px;\n}\n\n#table_item_candidates a{\n    color: #1ac1c5;\n    font-size: 12px;\n}\n\n.ic_avatar{\n  display: inline-block;\n  float: left;\n  margin-top: 2px;\n  border: 1px solid #f2f2f2;\n  border-radius: 50%;\n}\n\n#full-candidates{\n  width: 561px;\n  max-height: 525px;\n}\n\n#empty-candidates{\n    margin-top: 45px;\n    height:125px; \n    width: 500px;\n}\n\n#empty-candidates p{\n    font-size: 18px;\n    color: #9b9b9b;\n    \n}\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/item-candidates/item-candidates.component.css
// module id = ../../../../../src/app/pages/item-candidates/item-candidates.component.css
// module chunks = main